var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-lead-form-page"},[_c('iframe',{staticClass:"lead-form-iframe",attrs:{"src":_vm.leadFormUrl,"title":"Enquiry Form","frameborder":"0","allow":"clipboard-write","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }